import { MockedResponse } from '@apollo/client/testing';
import { TeachersMetaQuery as TeachersMetaQueryType } from 'core';
import { TeachersMetaQuery } from 'core/operations';

export const mockTeachersMetaResponse: MockedResponse<TeachersMetaQueryType> = {
  request: {
    query: TeachersMetaQuery,
    variables: {},
  },
  result: {
    data: {
      metaTeachers: {
        totalCount: 12,
        applicationsCount: 24,
      },
    },
  },
};
